import React from 'react';
import { createGlobalStyle } from 'styled-components';

import { buttonDefault, Color, Fonts, h1Default, h2Default, h3Default, h4Default, h5Default, hover, pDefault } from 'styles';

// https://google-webfonts-helper.herokuapp.com/fonts

const FontStyles = createGlobalStyle`
  
  h1, h2, h3, h4, h5, h6, p, li, button, div {
    color: ${Color.BLACK_SOUL};
  }
  
  h1, h2, h3, h4 {
    ${Fonts.POPPINS};
    font-weight: 700;
  }
  
  h5, h6, p, li, div {
    ${Fonts.GOTHIC};
    font-weight: 400;
  }
  
  h1 {
    ${h1Default};
  }
  
  h2 {
    ${h2Default};
  }
  
  h3 {
    ${h3Default};
  }
  
  h4 {
    ${h4Default};
  }
  
  h5 {
    ${h5Default};
  }
  
  p, div, li {
    ${pDefault};
  }
  
  div {
    line-height: 1;
  }
  
  p, li {
    a {
      text-decoration: underline;
    }
  }
  
  h1, h2, h3, h4, h5, h6 li, p {
    margin-bottom: 10px;
  }
  
  button {
    ${buttonDefault};
  }
  
  b, strong {
   font-weight: 700;
  }
`;

const LoadFonts = () => (
  <>
    <FontStyles />
  </>
);

export default LoadFonts;
